import { useQuery } from '@tanstack/react-query'
import { api, type TreatmentAnalyticsParams } from '@/lib/api-client'

/**
 * Fetch treatment analytics data for the Treatments tab
 * Includes popularity rankings, category breakdown, trends, and cross-sell analysis
 */
export function useTreatmentAnalytics(params?: TreatmentAnalyticsParams) {
  return useQuery({
    queryKey: ['analytics-treatments', params?.branchId, params?.startDate, params?.endDate, params?.limit],
    queryFn: () => api.analytics.treatments(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
